<template>
  <div>
    <div class="register-wrapper" v-loading="loading">
      <div id="register" style="background: #9ee7f6;" v-if="isRegister">
        <p class="title">农村卫生厕所智能化长效管护平台<span style="font-size: 22px;height:10%;">V3.0</span></p>

        <el-form
          :model="dataForm"
          status-icon
          :rules="rules"
          ref="dataForm"
          label-width="0"
          class="demo-ruleForm"
          style="width: 40%; margin-left: 35%; margin-top: 90px;height:70%;"
        >
          <el-form-item prop="account">
            <el-input style="width: 100%" v-model="dataForm.account" auto-complete="off" placeholder="账号"></el-input>
          </el-form-item>
          <el-form-item prop="pwd" style="width: 100%">
            <el-input type="password" v-model="dataForm.pwd" auto-complete="off"
                      placeholder="输入密码"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm" style="width:100%;">登录</el-button>
<!--            <p class="login" @click="gotoRegist">没有账号？立即注册</p>-->
            <!--<router-link to='/RegisterAccount'>没有账号？立即注册</router-link>-->
            <!-- <button @click="gotoRegist" class="btn btn-success">没有账号？立即注册</button>-->
          </el-form-item>
        </el-form>
        <p style="font-size: 15px; height:10%;" class="title">Copyright © 2019 - 2029 安徽卓新信息科技有限公司 版权所有</p>

      </div>

      <registerAccount v-if="!isRegister" v-on:listenToChildEvent="showMsgFromChild"></registerAccount>
    </div>
  </div>
</template>
<script>
    import registerAccount from './RegisterAccount'
    export default {
        name: "Register",
        components: {
            registerAccount
        },
        data() {
            // <!--验证手机号是否合法-->
            let checkName = (rule, value, callback) => {
                if (value === '' || value.trim() === '') {
                    callback(new Error('请输入账号'))
                } else {
                    callback()
                }
            }
            // <!--验证密码-->
            let validatePass = (rule, value, callback) => {
                if (value === "" || value.trim() === "") {
                    callback(new Error("请输入密码"))
                }
            }

            return {
                isRegister: true, // 判断登录或注册
                dataForm: {
                    account: '',
                    pwd: ''
                },
                rules: {
                    account: [{validator: checkName, trigger: 'change'}],
                    pwd: [{validator: validatePass, trigger: 'change'}],
                },
                isDisabled: false, // 是否禁止点击发送验证码按钮
                flag: true,
                loading: false
            }
        },
        methods: {
            // <!--提交登录-->
            submitForm: function () {
                // 登录
                let _this = this
                let params = this.dataForm
                _this.loading = true
                let param = {
                    info: params,
                    baseService: 'TGcUserServiceImpl',
                    type: 'login',
                }
                _this.FUNCTIONS.systemFunction.jsonPost(
                    _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
                    param,
                    resultData => {
                        _this.loading = false;
                        if (resultData.code == '200') {
                            //window.location.reload()
                            localStorage.setItem('gcUserInfo', JSON.stringify(resultData.obj.user))
                            this.$router.push({ path: '/' })
                            if (resultData.obj.user.cjdwdm) {
                              this.getTreeByCode(resultData.obj.user.ssqhdm);
                            }
                        } else {
                            _this.$message({
                                showClose: true,
                                message: resultData.errorMsg,
                                type: 'warning'
                            })
                        }
                    },
                    () => {
                        _this.loading = false
                        _this.$message({
                            showClose: true,
                            message: '请求异常，请联系管理员～',
                            type: 'error'
                        })
                    }
                )
            },
            //获取子组件传递的值
            showMsgFromChild: function (data){
                this.isRegister = data;
            },

            // <!--进入注册页-->
            gotoRegist: function () {
                this.isRegister = false;
            },

            // 根据登录人code 获取区划树(县级显示全部 乡镇显示所属乡镇下的)
            getTreeByCode(code) {
                let _this = this;
                let param = {
                    // baseService: 'TGcOrganizationServiceImpl',
                    baseService: _this.GLOBAL.config.baseServiceType.TGcOrganizationServiceImpl,
                    // type: 'getTreeTwo',
                    type: 'getTreeCode',
                    info: code
                }
                _this.FUNCTIONS.systemFunction.jsonPost(
                    _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
                    param,
                    resultData => {
                        if (resultData) {
                            localStorage.setItem(_this.GLOBAL.config.orgTreeName, JSON.stringify(resultData.obj))
                        } else {

                        }
                    }
                )
            }
        }
    }
</script>

<style scoped>
  .loading-wrapper {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: #aedff8;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .register-wrapper img {
    position: absolute;
    z-index: 1;
  }

  .register-wrapper {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  }

  #register {
    max-width: 100%;
    /* margin: 20px auto; */
    background: #fff;
    padding: 20px 40px;
    /* border-radius: 10px; */
    position: relative;
    z-index: 9;
    height: 100%;
  }

  .title {
    font-size: 26px;
    line-height: 50px;
    font-weight: bold;
    margin: 10px;
    text-align: center;
  }

  .el-form-item {
    text-align: center;
  }

  .login {
    margin-top: 10px;
    font-size: 14px;
    line-height: 22px;
    color: #1ab2ff;
    cursor: pointer;
    text-align: left;
    text-indent: 8px;
    width: 160px;
  }

  .login:hover {
    color: #2c2fd6;
  }

  .code >>> .el-form-item__content {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .code button {
    margin-left: 20px;
    width: 140px;
    text-align: center;
  }

  .el-button--primary:focus {
    background: #409EFF;
    border-color: #409EFF;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/view/Login.vue